import { render, staticRenderFns } from "./FormRatingSize.vue?vue&type=template&id=aa5f6850"
import script from "./FormRatingSize.vue?vue&type=script&lang=js"
export * from "./FormRatingSize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports